"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionalCountryCodes = exports.amazonSites = void 0;
exports.amazonSites = {
    ARE: {
        retailHost: "amazon.ae",
        vendorHost: "vendorcentral.amazon.me",
        endpoint: "mws.amazonservices.ae",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A2VIGQ35RCS4UG",
        amazonSellerIds: ["A2KKU8J8O8784X"],
        uniqueCurrency: "AED",
        timezone: "Asia/Dubai",
    },
    AUS: {
        retailHost: "amazon.com.au",
        vendorHost: "vendorcentral.amazon.com.au",
        endpoint: "mws.amazonservices.com.au",
        advertisingEndpoint: "advertising-api-fe.amazon.com",
        marketplaceId: "A39IBJ37TRP1C6",
        amazonSellerIds: ["ANEGB3WVEVKZB"],
        uniqueCurrency: "AUD",
        timezone: "Australia/Sydney",
    },
    BEL: {
        retailHost: "amazon.com.be",
        vendorHost: "vendorcentral.amazon.com.be",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "AMEN7PMS3EDWL",
        amazonSellerIds: ["A3Q3FYJVX702M2"],
        timezone: "Europe/Paris",
    },
    BRA: {
        retailHost: "amazon.com.br",
        vendorHost: "vendorcentral.amazon.com.br",
        endpoint: "mws.amazonservices.com",
        advertisingEndpoint: "advertising-api.amazon.com",
        marketplaceId: "A2Q3Y263D00KWC",
        amazonSellerIds: ["A1ZZFT5FULY4LN"],
        uniqueCurrency: "BRL",
        timezone: "America/Los_Angeles",
    },
    CAN: {
        retailHost: "amazon.ca",
        vendorHost: "vendorcentral.amazon.ca",
        endpoint: "mws.amazonservices.ca",
        advertisingEndpoint: "advertising-api.amazon.com",
        marketplaceId: "A2EUQ1WTGCTBG2",
        amazonSellerIds: ["A3DWYIK6Y9EEQB"],
        uniqueCurrency: "CAD",
        timezone: "America/Los_Angeles",
    },
    DEU: {
        retailHost: "amazon.de",
        vendorHost: "vendorcentral.amazon.de",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A1PA6795UKMFR9",
        amazonSellerIds: ["A3JWKAKR8XB7XF"],
        timezone: "Europe/Paris",
    },
    EGY: {
        retailHost: "amazon.eg",
        vendorHost: "vendorcentral.amazon.me",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "ARBP9OOSHTCHU",
        amazonSellerIds: ["A1ZVRGNO5AYLOV"],
        uniqueCurrency: "EGP",
        timezone: "Africa/Cairo",
    },
    ESP: {
        retailHost: "amazon.es",
        vendorHost: "vendorcentral.amazon.es",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A1RKKUPIHCS9HS",
        amazonSellerIds: ["A1AT7YVPFBWXBL"],
        timezone: "Europe/Paris",
    },
    FRA: {
        retailHost: "amazon.fr",
        vendorHost: "vendorcentral.amazon.fr",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A13V1IB3VIYZZH",
        amazonSellerIds: ["A1X6FK5RDHNB96"],
        timezone: "Europe/Paris",
    },
    GBR: {
        retailHost: "amazon.co.uk",
        vendorHost: "vendorcentral.amazon.co.uk",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A1F83G8C2ARO7P",
        amazonSellerIds: ["A3P5ROKL5A1OLE"],
        uniqueCurrency: "GBP",
        timezone: "Europe/London",
    },
    IND: {
        retailHost: "amazon.in",
        vendorHost: "www.vendorcentral.in",
        endpoint: "mws.amazonservices.in",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A21TJRUUN4KGV",
        amazonSellerIds: ["AT95IG9ONZD7S"],
        uniqueCurrency: "INR",
        timezone: "Asia/Kolkata",
    },
    IRL: {
        retailHost: "amazon.ie",
        vendorHost: "vendorcentral.amazon.ie",
        endpoint: "mws.amazonservices.ie",
        advertisingEndpoint: "advertiing-api-eu.amazon.com",
        marketplaceId: "A28R8C7NBKEWEA",
        amazonSellerIds: [],
        timezone: "Europe/Dublin",
    },
    ITA: {
        retailHost: "amazon.it",
        vendorHost: "vendorcentral.amazon.it",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "APJ6JRA9NG5V4",
        amazonSellerIds: ["A11IL2PNWYJU7H"],
        timezone: "Europe/Paris",
    },
    JPN: {
        retailHost: "amazon.co.jp",
        vendorHost: "vendorcentral.amazon.co.jp",
        endpoint: "mws.amazonservices.jp",
        advertisingEndpoint: "advertising-api-fe.amazon.com",
        marketplaceId: "A1VC38T7YXB528",
        amazonSellerIds: ["AN1VRQENFRJN5"],
        uniqueCurrency: "JPY",
        timezone: "Asia/Tokyo",
    },
    MEX: {
        retailHost: "amazon.com.mx",
        vendorHost: "vendorcentral.amazon.com.mx",
        endpoint: "mws.amazonservices.com.mx",
        advertisingEndpoint: "advertising-api.amazon.com",
        marketplaceId: "A1AM78C64UM0Y8",
        amazonSellerIds: ["AVDBXBAVVSXLQ"],
        uniqueCurrency: "MXN",
        timezone: "America/Los_Angeles",
    },
    NLD: {
        retailHost: "amazon.nl",
        vendorHost: "vendorcentral.amazon.nl",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A1805IZSGTT6HS",
        amazonSellerIds: ["A17D2BRD4YMT0X"],
        timezone: "Europe/Amsterdam",
    },
    POL: {
        retailHost: "amazon.pl",
        vendorHost: "vendorcentral.amazon.pl",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A1C3SOZRARQ6R3",
        amazonSellerIds: ["A2R2221NX79QZP"],
        uniqueCurrency: "PLN",
        timezone: "Europe/Warsaw",
    },
    SAU: {
        retailHost: "amazon.sa",
        vendorHost: "vendorcentral.amazon.me",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A17E79C6D8DWNP",
        amazonSellerIds: ["A2XPWB6MYN7ZDK"],
        uniqueCurrency: "SAR",
        timezone: "Asia/Riyadh",
    },
    SGP: {
        retailHost: "amazon.sg",
        vendorHost: "vendorcentral.amazon.com.sg",
        endpoint: "mws-fe.amazonservices.com",
        advertisingEndpoint: "advertising-api-fe.amazon.com",
        marketplaceId: "A19VAU5U5O7RUS",
        amazonSellerIds: ["ACT6OAM3OSC9S"],
        uniqueCurrency: "SGD",
        timezone: "Asia/Singapore",
    },
    SWE: {
        retailHost: "amazon.se",
        vendorHost: "vendorcentral.amazon.se",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A2NODRKZP88ZB9",
        amazonSellerIds: ["ANU9KP01APNAG"],
        uniqueCurrency: "SEK",
        timezone: "Europe/Stockholm",
    },
    TUR: {
        retailHost: "amazon.com.tr",
        vendorHost: "vendorcentral.amazon.com.tr",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "A33AVAJ2PDY3EV",
        amazonSellerIds: ["A5I6TQH9DZ7KM"],
        uniqueCurrency: "TRY",
        timezone: "Europe/Istanbul",
    },
    USA: {
        retailHost: "amazon.com",
        vendorHost: "vendorcentral.amazon.com",
        endpoint: "mws.amazonservices.com",
        advertisingEndpoint: "advertising-api.amazon.com",
        marketplaceId: "ATVPDKIKX0DER",
        amazonSellerIds: ["A4XRJ8S0WXSO0", "A2R2RITDJNW1Q6"],
        uniqueCurrency: "USD",
        timezone: "America/Los_Angeles",
    },
    ZAF: {
        retailHost: "amazon.co.za",
        vendorHost: "vendorcentral.amazon.co.za",
        endpoint: "mws-eu.amazonservices.com",
        advertisingEndpoint: "advertising-api-eu.amazon.com",
        marketplaceId: "AE08WJ6YKNBMC",
        amazonSellerIds: ["A34KVLZUJN6MA"],
        uniqueCurrency: "ZAR",
        timezone: "Africa/Johannesburg",
    },
};
exports.regionalCountryCodes = {
    NA: ["BRA", "CAN", "MEX", "USA"],
    EU: [
        "ARE",
        "DEU",
        "EGY",
        "ESP",
        "FRA",
        "IRL",
        "BEL",
        "GBR",
        "IND",
        "ITA",
        "NLD",
        "POL",
        "SAU",
        "SWE",
        "TUR",
        "ZAF",
    ],
    AP: ["SGP", "AUS", "JPN"],
};
//# sourceMappingURL=mwsConstants.js.map